export default __webpack_public_path__ + "static/media/greenstaarWhite.db7e6195.png";